import { TYPE } from 'vue-toastification';
import Vue from 'vue';
function isType(string) {
    return [TYPE.DEFAULT, TYPE.SUCCESS, TYPE.ERROR, TYPE.INFO, TYPE.WARNING].includes(string);
}
export default class Notifier {
    static sendNotificationsIfNeeded(options) {
        if (Object.hasOwnProperty.call(options, 'message') && options.message) {
            const message = options.message;
            let status = null;
            if (options.status && isType(options.status)) {
                status = options.status;
            }
            Vue.$toast(message, {
                type: status !== null && status !== void 0 ? status : TYPE.DEFAULT,
            });
        }
        if (Object.hasOwnProperty.call(options, 'success') && options.success) {
            Vue.$toast.success(options.success);
        }
        if (Object.hasOwnProperty.call(options, 'error') && options.error) {
            Vue.$toast.error(options.error);
        }
        if (Object.hasOwnProperty.call(options, 'info') && options.info) {
            Vue.$toast.info(options.info);
        }
        if (Object.hasOwnProperty.call(options, 'warning') && options.warning) {
            Vue.$toast.warning(options.warning);
        }
    }
}
